import { render, staticRenderFns } from "./SfArrow.vue?vue&type=template&id=3a6049b3&functional=true&"
import script from "./SfArrow.vue?vue&type=script&lang=js&"
export * from "./SfArrow.vue?vue&type=script&lang=js&"
import style0 from "./SfArrow.vue?vue&type=style&index=0&id=3a6049b3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports